import Loading from "../../modules/pages/Loading";
import Footer from "../Footer";
import Header from "../Header";
import Base from "./Base";

const Frontend = () => {
    return (
        <>
            <Header />
            <Base />
            <Footer />
            <Loading/>
        </>
    );
};

export default Frontend;
